import {useEffect, useState} from 'react';
import _ from 'lodash';

export const useDynamicTableHeight = (containerRef, offset = 135) => {
  const [height, setHeight] = useState(500);


  useEffect(() => {
    const calculateHeight = _.throttle(() => {
      if (containerRef.current) {
        const {top} = containerRef.current.getBoundingClientRect();
        setHeight(window.innerHeight - top - offset);
      }
    });
    calculateHeight();
    window.addEventListener('resize', calculateHeight);
    return () => calculateHeight.cancel();
  }, [containerRef, offset]);
  return height;
};